var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_3148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.26149 0 0 4.26149 0 9.5C0 14.7385 4.26149 19 9.5 19C14.7385 19 19 14.7385 19 9.5C19 4.26149 14.7385 0 9.5 0Z",
    fill: "currentColor",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3145 7.48685L9.1686 12.6326C9.01422 12.787 8.81157 12.8647 8.60892 12.8647C8.40627 12.8647 8.20361 12.787 8.04923 12.6326L5.47636 10.0597C5.16673 9.75023 5.16673 9.24983 5.47636 8.94035C5.78585 8.63071 6.2861 8.63071 6.59573 8.94035L8.60892 10.9535L13.1951 6.36748C13.5046 6.05785 14.0049 6.05785 14.3145 6.36748C14.624 6.67696 14.624 7.17722 14.3145 7.48685Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_3148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.b2bd513dddb69f131240147f7fd5519c.svg";
export { ForwardRef as ReactComponent };